import React from "react";
import { FaPhone } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { metaPixelEvents } from "../utils/metaPixel";
import { useFooterData } from "../Apis/useApiQueries";
import "../styles/FloatingPhone.scss";

const FloatingPhone = () => {
  console.log("FloatingPhone component rendered");
  const location = useLocation();
  const isAcademyPage = location.pathname === "/academy";
  const { siteDetails } = useFooterData();
  
  const handlePhoneClick = () => {
    // Track the phone click event
    metaPixelEvents.trackPhoneClick();
    
    // Use the phone number from site details, fallback to hardcoded if not available
    const phoneNumber = siteDetails.data?.phone || "+972532268138";
    window.location.href = `tel:${phoneNumber}`;
  };

  return (
    <div 
      className={`floating-phone ${isAcademyPage ? 'academy-style' : ''}`}
      onClick={handlePhoneClick}
      role="button"
      tabIndex={0}
      aria-label="התקשרו אלינו"
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handlePhoneClick();
        }
      }}
    >
      <FaPhone className="phone-icon" />
      <div className="tooltip">התקשרו אלינו</div>
    </div>
  );
};

export default FloatingPhone;
